<template>
    <div class="index page-wrapper" :end="!pageData?.can_vote" :class="{ 'login-bottom': true, 'in-second': !storeCommon.inTopTab && ![EActivityStatus.NotStart, EActivityStatus.End].includes(pageData?.activity_status?.toString()) }">
        <QmHeader v-if="!storeCommon.inTopTab" ref="headerRef" :config="headerConfig" @navClick="onNavClick"></QmHeader>
        <template v-if="[EActivityStatus.Start, EActivityStatus.EndCanLottery, EActivityStatus.EndOnlyShow].includes(pageData?.activity_status?.toString())">
            <div class="index-content">
                <div class="header-img" :class="[storeCommon.inTopTab ? headerImg.top : headerImg.second]"></div>
                <div :class="['wish-home-img-logo']"></div>
                <div class="content-list">
                    <div class="title-prize"></div>
                    <topPrize class="mgt-14" />
                    <div class="title-wishlist mgt-24"></div>
                    <rankList ref="rankListRef" class="mgt-20" />
                    <qmWxBtn v-if="!storeCommon.systemInfo.isHarmony">
                        <div ref="rankJumpRef" class="wish-home-img-jump" @click.stop="handleZhPreClick">前往/下载纵横小说查看榜单<span class="icon-arrow"></span></div>
                    </qmWxBtn>
                    <template v-if="pageData?.can_vote">
                        <topic />
                    </template>
                </div>
                <p class="rule-text" :second="!storeCommon.inTopTab" @click="handleRule">
                    <qm-wx-btn>
                        <img src="@/assets/images/rule.png" alt="">
                    </qm-wx-btn>
                </p>
            </div>
            <p class="bottom-ai-text" :end="!pageData?.can_vote && storeCommon.systemInfo.isHarmony" :ios="platform === 'ios'">本页面素材含AI生成内容</p>
            <!-- 底部slogan -->
            <QSlogan ref="sloganRef" :end="!pageData?.can_vote" :ios="platform === 'ios'" :title="platform === 'ios' ? '本活动与设备制作商Apple Inc.无关' : ''" class="slogan" skin="dark" :client="'freereader'"></QSlogan>
            <!-- 打开APP按钮组件 -->
            <q-open-app v-if="!inQmApp" ref="openAppRef" :params="openAppParams" />
        </template>
        <q-empty v-if="[EActivityStatus.End].includes(pageData?.activity_status?.toString())" class="empty-page" type="activityEnd" tip="活动已结束"></q-empty>
        <q-empty v-if="[EActivityStatus.NotStart].includes(pageData?.activity_status?.toString())" class="pass-text" type="activityEnd" tip="活动不在有效期"></q-empty>
        <q-empty v-if="isErrors" class="pass-text" type="error" tip="页面异常，请重试" @click="getPageData(true)"></q-empty>
        <QShare
            v-stop-native-touch
            v-model="isShowShare"
            :share-info="shareInfo"
            :typeList="shareTypeListDynamic"
            :statusBarHeight="statusBarHeight"
            :removeBase64Prefix="storeCommon.systemInfo.isAndroid"
            @share="shareSuccess"></QShare>
        <prizePop @refresh="refreshRankList" />
        <voteHistory ref="voteHistoryRef" />
        <taskModule @refresh="refreshData" @share="callShare" ref="taskRef" />
        <QPageLoading isFullScreen v-if="store.showPageLoading" />
        <mine v-if="[EActivityStatus.Start, EActivityStatus.EndCanLottery, EActivityStatus.EndOnlyShow].includes(pageData?.activity_status?.toString()) && pageData?.can_vote" @click="handleMineClick" />
    </div>
</template>
<script lang="ts" setup>
import { ref, onMounted, computed, watch } from 'vue';
import Vue from 'vue';
import { usePageBaseInit } from '@common/hooks';
import { QSlogan, QEmpty, QShare, QPageLoading } from '@q-front-npm/h5-ui';
import qOpenApp from '@common/components/q-open-app/index.vue';
import QmHeader from '@common/components/qm-header/index.vue';
import { useStoreCommon } from '@common/store/common';
import { useStore } from './store';
import { jsbSupportMap, addNABackToWebviewEvent, openShareTab, ShareType, ShareChannel, closeWebview, jsbReportV3, openWebview, schemaSingle } from '@q-front-npm/jsbridge';
import { apiPageData, apiGetUserInfo, apiGetRewardPop, apiCompleteTask } from './http/api';
import { handleLogin } from '@common/assets/ts/utils';
import { EActivityStatus, shareTypeList } from '@common/assets/ts/const';
import QmWxBtn from '@common/components/qm-wx-btn.vue';
import taskModule from './components/task/index.vue';
import prizePop from './components/prize.vue';
import { useLowVersionRefreshToken } from '@common/hooks';
import '@q-front-npm/h5-ui/lib/q-btn/style/freereader.css';

import { useIntersectionObserver } from '@common/hooks/useIntersectionObserver';
import { shareTypeText } from '@common/assets/ts/const';

import voteHistory from './components/module/vote-history.vue';
import mine from './components/mine.vue';
import topPrize from './components/top-prize.vue';
import rankList from './components/rank/index.vue';
import topic from './components/topic.vue';

const storeCommon = useStoreCommon();
usePageBaseInit();
const { inQmApp, platform, } = storeCommon.systemInfo;

const store = useStore();

const videoRef = ref();
// 组件引用
const openAppRef = ref();

// 打开APP并关闭弹窗
const openAPP = () => {
    openAppRef.value?.openQimaoApp();
};
Vue.prototype.$openAPP = openAPP;

const statusBarHeight = computed(() => {
    return storeCommon.inTopTab ? +storeCommon.inTopTabNavHeight : +storeCommon.statusBarHeight;
});

const isLogin = computed(() => {
    return !['0', '3'].includes(storeCommon.userInfo.user_type?.toString() || '');
});

const headerImg = computed(() => {
    if (storeCommon.serverTime < new Date('2026-04-01').getTime()) {
        return {second: 'header-img-second1', top: 'header-img-nomal1',};
    } else if (storeCommon.serverTime < new Date('2026-04-08').getTime()) {
        return {second: 'header-img-second2', top: 'header-img-nomal2',};
    } else {
        return {second: 'header-img-second3', top: 'header-img-nomal3',};
    }
});

const headerRef = ref();
const headerConfig = {
    title: '番外许愿季',
    styleConfig: {
        default: {
            title: {
                color: 'transparent',
            },
            statusBar: 'white',
        },
        fixed: {
            title: {
                color: '#fff',
            },
            text: {
                color: '#fff',
            },
            bg: {
                background: '#E13B1C',
            },
            statusBar: 'white',
        },
    },
};
headerRef.value?.onUpdate(headerConfig);

// 打开APP参数（安卓/iOS）
const shareUrl = `https://xiaoshuo.wtzw.com/h5/activity/freereaderWishBooks/sidePanel/index?full_screen=3`;
const shareImageUrl = 'https://cdn-front.wtzw.com/manual-upload/activity/weixin/wish-book.jpg';
const shareTypeListDynamic = ref([...shareTypeList]);
const shareInfo = ref({});
const shareConfig = {
    title: '七猫&纵横·首届番外许愿季来了！',
    desc: '你许愿，ta填坑。那些年欠你的结局，我们一笔一笔，写回来。',
    thumbimage: shareImageUrl,
    imageUrl: shareImageUrl,
    link: shareUrl.replace(/xiaoshuo.wtzw.com/, 'app-share.wtzw.com'),
    type: ShareType.link,
    src: '',
    // ...store.bookFriendDetail,
};

const openAppParams = {
    androidDeeplink: `freereader://webview_newweb?param=${JSON.stringify({ url: shareUrl, })}`,
    iosDeeplink: `freereader://webview_newweb?param={"url":"${shareUrl}"}&skipad=1`,
    ...shareConfig,
};

const isShowShare = ref(false);
const onNavClick = async(e: Record<string, any>) => {
    if (e.type === 'share' && [EActivityStatus.Start, EActivityStatus.EndCanLottery, EActivityStatus.EndOnlyShow].includes(pageData.value?.activity_status?.toString())) {
        // jsbReportV3('25zsds_share_#_click', {});
        shareTypeListDynamic.value = [...shareTypeList];
        shareInfo.value = {
            ...shareConfig,
            type: ShareType.link,
        };
        isShowShare.value = true;
    }
};

// 设置页面数据
const pageData = ref<Record<string, any>>({
    activity_status: EActivityStatus.Start.toString(),
});
const isErrors = ref(false);
const rankJumpRef = ref();
const getPageData = async(isFirst: boolean = false) => {
    isErrors.value = false;
    let res = {};
    try {
        res = await apiPageData();
    } catch (err: any) {
        isErrors.value = true;
    }
    if (isErrors.value) return;

    pageData.value = res;

    storeCommon.setUserInfo(res?.user_info || {});
    // 低版本刷新token
    useLowVersionRefreshToken(res?.user_info?.uid);

    // 登录用户自动完成签到任务，并更新任务状态
    // if (pageData.value?.sign_in_just_completed) {
    //     Vue.prototype.$toast('恭喜你，签到成功，许愿票+1');
    // }

    store.setPageData(pageData.value);

    if (isFirst) {
        setTimeout(() => {
            if (rankJumpRef.value) {
                const { targetRef, isIntersecting, disconnect, } = useIntersectionObserver({
                    threshold: 1,
                });
                targetRef.value = rankJumpRef.value as HTMLElement;
                watch(() => isIntersecting.value, (newVal) => {
                    if (newVal) {
                        jsbReportV3('26wish_btn_button_show', {});
                        disconnect();
                    }
                }, { immediate: true, once: true, });
            }
        }, 100);
    }
    // getRewardInfo();
};
getPageData(true);

const refreshData = async() => {
    const res = await apiPageData();
    if (res?.errors) return;
    pageData.value = res;
    store.setPageData(pageData.value);
};
const rankListRef = ref();
const refreshRankList = ({book_id, count,}: {book_id: string, count: number}) => {
    rankListRef.value?.resetRankList?.({book_id, count,});
    refreshData();
};

// 登录回调
if (storeCommon.inTopTab) {
    (window as any).book_mall_activity_appear = (status: string | number) => {
        videoRef.value?.pauseVideo();
        if (+status === 1) {
            console.error('book_mall_activity_appear 1');
            getPageData();
        }
    };
} else {
    addNABackToWebviewEvent((type: string) => {
        console.error('resume', type);
        videoRef.value?.pauseVideo();
        if (type === 'resume') {
            getPageData();
        }
    });
}

// 分享
const callShare = () => {
    if (!jsbSupportMap?.app?.share) return Vue.prototype.$toast('请升级至最新版本参与活动');

    shareInfo.value = {
        ...shareConfig,
        type: ShareType.link,
    };
    // if (!handleLogin(storeCommon.userInfo.user_type)) {
    //     return;
    // }
    // jsbReportV3('eyemasterpreheat_shareforcoupon-btn_button_click', {});
    isShowShare.value = true;
};
const shareSuccess = (shareData: Record<string, any>) => {
    console.log('-----------------shareSuccess', shareData);
    pageData.value.task_info.forEach(async(item: Record<string, any>) => {
        console.log('-----------------item', item);
        // if (item.key === 'share' && item.status === '0') {
        //     console.log('-----------------item share', item);
        //     // 完成分享任务
        //     await apiCompleteTask({
        //         activity_key: storeCommon.activityKey,
        //         task_key: item.key,
        //         to_status: '2',
        //     });

        //     getPageData();
        //     return true;
        // }
        return false;
    });

    const { shareType = '', } = shareData;
    jsbReportV3('26wish_share_button_click', { btn_wenan: shareTypeText[shareType as keyof typeof shareTypeText], });
};

// 规则
const handleRule = () => {
    if (!storeCommon.systemInfo.inQmApp) return openAPP();
    openWebview('https://xiaoshuo.wtzw.com/freereader-rules/69ae7731225840ebf8fc2234/?side_panel=1');
};

const handleZhPreClick = () => {
    jsbReportV3('26wish_btn_button_click', {});
    store.goToZh(2);
};

// 二级页面 页面往上提100px
if (!storeCommon.inTopTab) {
    // document.body.style.position = 'absolute';
    // document.body.style.top = '-2rem';
    // document.body.style.left = 'calc(50vw - 3.6rem)';
}

const taskRef = ref();
const voteHistoryRef = ref();
const handleMineClick = (type: string) => {
    console.log('handleMineClick', type);
    if (type === 'task') return taskRef.value?.open();
    if (type === 'history') return voteHistoryRef.value?.open();
};

onMounted(() => {
    document.title = headerConfig.title;
    jsbReportV3('26wish_full_#_view', {});
    // store.getZhUrl();
});

</script>
<style lang="scss">
@import '@/assets/styles/iconfont.scss';
@import '@/assets/styles/sprite.scss';
@import '@/assets/styles/sprites.scss';
:root {
    --q-overlay-bg-color: rgba(0, 0, 0, 0.8)!important;
}
* {
    box-sizing: border-box;
}
.in-second {
    margin-top: -200px;
}
html, body {
    background: #DF2D15;
    // background: linear-gradient(to bottom, #FF5636 0%, #DF2D15 100%);
}

.q-overlay {
    position: absolute;
    width: 100vw;
    left: calc((100% - 100vw) / 2);
}
// .img-rule-img {
//     position: absolute;
//     top: 372px;
//     right: 0;
//     z-index: 20;
//     width: 48px;
// }
.rule-text {
    width: 64px;
    height: 40px;
    border-right: none;
    // border-image: linear-gradient(90deg, rgba(255, 255, 255, 0.59), rgba(255, 255, 255, 0)) 1 1;
    position: absolute;
    top: 324px;
    right: 0;
    z-index: 20;
    &[second] {
        top: 424px;
    }
    img {
        width: 64px;
    }
}
.slogan {
    padding: 10px 0!important;
}
.index {
    background: linear-gradient(to bottom, #FF5636 0%, #DF2D15 100%);
    @include sprites-index($index-sprites);
    position: relative;
    // padding-bottom: 220px;
    &-content{
        position: relative;
        z-index: 10;
    }
    &::before{
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1210px;
        // background: url('@/assets/images/img_bg_footer.jpg') no-repeat center center;
        background-size: 100% 100%;
        z-index: 1;
    }
}
::v-deep .end {
    box-sizing: border-box;
    padding-top: calc((100vh - 160px) * 0.26);
    width: 100%;
    height: 100vh;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    .pic {
        box-sizing: border-box;
        padding-top: 70px;
        height: 496px;
        img {
            width: 558px;
            height: 356px;
        }
    }
}
.pass-text {
    font-size: 24px;
    color: #111111;
    text-align: center;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    width: 720px;
    position: fixed;
    top: 0;
    left: calc((100% - 720px) / 2);
    z-index: 999;
}
.bottom-ai-text {
    font-size: 20px;
    color: #EBF5FF;
    line-height: 30px;
    text-align: center;
    width: 100%;
    opacity: 0.3;
}
.empty-page {
    width: 720px;
    height: 100vh!important;
    display: flex;
    align-items: center;
    justify-content: center;
}
.index-content {
    padding-top: 884px;
    padding-bottom: 48px;
}
.header-img {
    width: 100%;
    min-height: 1344px;
    height: 1344px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
}
.header-img-second1 {
    background: url('@/assets/images/wish_home_img_headimg.png') no-repeat center center !important;
    background-size: 100% 100% !important;
}
.header-img-nomal1 {
    background: url('@/assets/images/wish_home_img_huodongheadimg.png') no-repeat center center;
    background-size: 100% 100%;
}

.header-img-second2 {
    background: url('@/assets/images/wish_home_img_headimg2.png') no-repeat center center !important;
    background-size: 100% 100% !important;
}
.header-img-nomal2 {
    background: url('@/assets/images/wish_home_img_huodongheadimg2.png') no-repeat center center;
    background-size: 100% 100%;
}

.header-img-second3 {
    background: url('@/assets/images/wish_home_img_headimg3.png') no-repeat center center !important;
    background-size: 100% 100% !important;
}
.header-img-nomal3 {
    background: url('@/assets/images/wish_home_img_huodongheadimg3.png') no-repeat center center;
    background-size: 100% 100%;
}
.title-discussion, .title-wishlist, .title-prize {
    margin: 0 auto;
}
.mgt-14 {
    margin-top: 14px!important;
}
.mgt-24 {
    margin-top: 24px!important;
}
.mgt-20 {
    margin-top: 20px!important;
}
.wish-home-img-logo, .no-free {
    position: absolute;
    transform: translateX(calc(360px - 50%));
    top: 310px;
    z-index: 1;
}
.wish-home-img-jump {
    width: 546px;
    height: 130px;
    line-height: 130px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    color: #FFEEB8;
    margin-top: 120px;
    background: url('@/assets/images/wish_home_img_jump.png') no-repeat center center;
    background-size: 100% 100%;
    .icon-arrow {
        transform: scale(1.5);
    }
}
.login-bottom {
    padding-bottom: 200px;
    .bottom-ai-text[end] {
        margin-top: 100px!important;
    }
    &[end] {
        padding-bottom: 40px!important;
    }
}
.q-share .q-popup {
    z-index: 2001!important;
}

</style>

